// 剧目销售报表 - 共享样式（与 demo-开发用.html 视觉对齐）
import styled from 'styled-components';

export const PageWrap = styled.div`
  padding: 16px 24px 32px;
  /* background: #f5f6f9; */
  min-height: 100%;
`;

export const Sec = styled.section`
  margin-bottom: 12px;
`;

export const SecTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #212121;
  margin-bottom: 8px;
  em {
    font-style: normal;
    color: #8c939e;
    font-size: 12px;
    font-weight: 400;
    margin-left: 8px;
  }
`;

// 与 HTML .box 一致：白底 + 1px 边框 + 12px 圆角 + 20px padding
export const Box = styled.div`
  background: #fff;
  border: 1px solid #e2e7ec;
  border-radius: 12px;
  padding: 20px;
`;

// 查询条
export const Filters = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 28px;
  flex-wrap: wrap;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 48px;
  padding: 0 12px;
  min-width: 234px;
  border-bottom: 1px solid #e0e0e0;
  .k {
    color: #333;
    font-size: 12px;
    white-space: nowrap;
  }
  .v {
    color: #333;
    font-size: 14px;
  }
`;

export const Btns = styled.div`
  margin-left: auto;
  display: flex;
  gap: 16px;
`;

export const FilterBtn = styled.button`
  height: 40px;
  min-width: 108px;
  padding: 0 20px;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  border: 0;
  color: #fff;
  background: ${(p) => (p.primary ? '#165dff' : '#4e5969')};
`;

// 分组说明（销售总览的两段）
export const Grp = styled.div`
  font-size: 13px;
  color: #333;
  margin: 0 0 8px;
  em {
    font-style: normal;
    color: #8c939e;
    font-size: 12px;
    margin-left: 8px;
  }
`;

// 销售总览 KPI
export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border: 1px solid #e2e7ec;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
  background: #fff;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Kpi = styled.div`
  text-align: center;
  padding: 16px 8px;
  border-right: 1px solid #e2e7ec;
  &:last-child {
    border-right: 0;
  }
  .l {
    font-size: 12px;
    color: #616161;
    margin-bottom: 8px;
  }
  .v {
    font-size: 22px;
    font-weight: 600;
    color: ${(p) => (p.gold ? '#e67e22' : '#165dff')};
    font-variant-numeric: tabular-nums;
  }
`;

// 漏斗 / 地域 / 场次顶部 mini 摘要
export const Mini = styled.div`
  display: flex;
  align-items: stretch;
  border: 1px solid #e2e7ec;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 16px;
  overflow: hidden;
`;

export const MiniItem = styled.div`
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  & + & {
    border-left: 1px solid #e2e7ec;
  }
  .l {
    font-size: 12px;
    color: #8c939e;
  }
  .v {
    font-size: 20px;
    font-weight: 600;
    color: ${(p) => p.color || '#165dff'};
    margin-top: 4px;
  }
`;

// 图表双列
export const ChartsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const ChartCard = styled.div`
  background: #fff;
  border: 1px solid #e2e7ec;
  border-radius: 12px;
  padding: 0 0 12px;
`;

export const ChartHd = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding: 14px 20px 8px;
`;

export const Plot = styled.div`
  height: ${(p) => p.height || '204px'};
  position: relative;
  padding: 0 8px;
`;

// 报表表格：与 HTML table.report 一致
export const ReportTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  th,
  td {
    border: 1px solid #e8eaed;
    padding: 10px 12px;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
  }
  th {
    background: #f7f8fa;
    color: #616161;
    font-weight: 500;
    font-size: 12px;
  }
  th:first-child,
  td:first-child {
    text-align: left;
  }
  th:not(:first-child),
  td:not(:first-child) {
    text-align: right;
  }
  th.bar-cell,
  td.bar-cell {
    text-align: left;
  }
  .bar-bg {
    height: 10px;
    background: transparent;
  }
  .bar {
    height: 10px;
    background: #1565c0;
    border-radius: 2px;
  }
  .bar.light {
    background: #90caf9;
  }
  .bar.gray {
    background: #c9cdd4;
  }
`;

// 渠道拆分 split 布局
export const Split = styled.div`
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
  align-items: center;
`;

export const PieWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Foot = styled.p`
  font-size: 12px;
  color: #8c939e;
  margin-top: 12px;
`;

// 文字说明
export const Notes = styled.div`
  font-size: 13px;
  color: #333;
  line-height: 2;
`;

// 以下保留给老组件，避免外部引用报错
export const Card = styled.div`
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  margin-bottom: 12px;
`;

export const CardHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #e5e6eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  h2 {
    font-size: 14px;
    font-weight: 600;
  }
  .sub {
    color: #86909c;
    font-size: 12px;
    font-weight: 400;
    margin-left: 8px;
  }
`;

export const CardBody = styled.div`
  padding: 16px;
`;

export const GroupHead = styled.div`
  padding: 7px 16px;
  background: #f7f8fa;
  border-bottom: 1px solid #e5e6eb;
  font-size: 12px;
  color: #4e5969;
  em {
    font-style: normal;
    color: #86909c;
    margin-left: 8px;
  }
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
`;

export const KpiItem = styled.div`
  padding: 16px 12px;
  text-align: center;
  border-right: 1px solid #e5e6eb;
  &:last-child {
    border-right: none;
  }
  .l {
    color: #86909c;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .v {
    font-size: 22px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    color: ${(p) => (p.gold ? '#9a7326' : '#1f2329')};
  }
  .u {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    margin-left: 2px;
  }
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ChartBox = styled.div`
  height: ${(p) => p.height || '240px'};
  position: relative;
`;

export const Legend = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #86909c;
  i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin-right: 4px;
    vertical-align: -1px;
  }
`;

export const MiniKpis = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => p.cols || 3}, 1fr);
  gap: 0;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
  .item {
    padding: 12px;
    text-align: center;
    border-right: 1px solid #e5e6eb;
    background: #fafbfc;
    &:last-child {
      border-right: none;
    }
  }
  .l {
    font-size: 12px;
    color: #86909c;
  }
  .v {
    font-size: 18px;
    font-weight: 600;
    margin-top: 4px;
    color: ${(p) => p.color || '#1f2329'};
  }
`;

export const Note = styled.p`
  margin-top: 10px;
  font-size: 12px;
  color: #86909c;
  line-height: 1.7;
  b {
    color: #4e5969;
    font-weight: 500;
  }
`;

export const Caliber = styled.div`
  background: #fbfcfd;
  border: 1px solid #e5e6eb;
  border-left: 3px solid #165dff;
  border-radius: 3px;
  padding: 12px 14px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #4e5969;
  line-height: 1.9;
  h3 {
    font-size: 12px;
    font-weight: 600;
    color: #1f2329;
    margin-bottom: 4px;
  }
  ul {
    margin: 0;
    padding-left: 18px;
  }
`;

export const FilterBar = styled.div`
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  align-items: center;
  margin-bottom: 12px;
  .item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  label {
    color: #86909c;
    white-space: nowrap;
  }
  .val {
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    padding: 5px 12px;
    background: #fafbfc;
    min-width: 140px;
  }
`;

export const PageTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
  h1 {
    font-size: 18px;
    font-weight: 600;
  }
  .meta {
    color: #86909c;
    font-size: 12px;
    margin-top: 2px;
  }
`;

export const BadgeMust = styled.span`
  font-size: 11px;
  color: #009a29;
  background: #e8ffea;
  border: 1px solid #b7f0c0;
  padding: 1px 6px;
  border-radius: 2px;
  margin-left: 8px;
  font-weight: 400;
`;

export const BadgeLater = styled.span`
  font-size: 11px;
  color: #86909c;
  border: 1px solid #e5e6eb;
  padding: 1px 6px;
  border-radius: 2px;
  margin-left: 8px;
  font-weight: 400;
`;

export const DivLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 22px 0 10px;
  span {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    padding: 3px 10px;
    border-radius: 2px;
  }
  .p0 {
    background: #e8ffea;
    color: #009a29;
  }
  .p2 {
    background: #f2f3f5;
    color: #646a73;
  }
  .line {
    flex: 1;
    height: 1px;
    background: #e5e6eb;
  }
`;
